module.exports = __webpack_public_path__ + "static/media/jp.b4dbf8d2.svg";